import { NetworkStatus, gql } from '@apollo/client';

import { logError } from '@/imports/logging/ClientLogger';
import { useQueryWithPastDataDeprecated } from '@/imports/ui/useQueryWithPastData';

import { UsePublisherQuery_CurrentUser } from './graphql-types/UsePublisherQuery_CurrentUser';

const UsePublisherQuery_CurrentUserAST = gql`
  query UsePublisherQuery_CurrentUser {
    currentUser {
      _id
      proxyProfilePictureUrl(
        input: {
          w: 312
          h: 312
          fit: "facearea"
          facepad: 10.0
          mask: "ellipse"
          fm: "png"
        }
      )
      displayName
    }
  }
`;

export const usePublisherQuery = ():
  | {
      _id: string;
      name: string;
      profilePictureUrl?: string;
    }
  | { loading: true } => {
  const { data, networkStatus, error } =
    useQueryWithPastDataDeprecated<UsePublisherQuery_CurrentUser>(
      UsePublisherQuery_CurrentUserAST
    );

  if (networkStatus === NetworkStatus.loading) {
    return { loading: true };
  }

  if (error) {
    logError(error);
    throw error;
  }

  const currentUser = data?.currentUser;
  if (!currentUser) {
    throw new Error('No current user');
  }

  return {
    _id: currentUser._id,
    name: currentUser.displayName,
    profilePictureUrl: currentUser.proxyProfilePictureUrl ?? undefined,
  };
};
